/** Wi-Fi/モバイル判定 */
export const SET_WIFI_STATUS = "SET_WIFI_STATUS";